import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Watch = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M26 16C26 12.738 24.425 9.838 22 8V5C22 3.35 20.65 2 19 2H13C11.35 2 10 3.35 10 5V8C7.575 9.825 6 12.725 6 16C6 19.275 7.575 22.163 10 24V27C10 28.65 11.35 30 13 30H19C20.65 30 22 28.65 22 27V24C24.425 22.163 26 19.262 26 16ZM12 5C12 4.45 12.45 4 13 4H19C19.55 4 20 4.45 20 5V6.838C18.775 6.301 17.425 6 16 6C14.575 6 13.225 6.3 12 6.838V5ZM8 16C8 11.588 11.588 8 16 8C20.412 8 24 11.588 24 16C24 20.412 20.413 24 16 24C11.587 24 8 20.413 8 16ZM20 27C20 27.55 19.55 28 19 28H13C12.45 28 12 27.55 12 27V25.163C13.225 25.701 14.575 26 16 26C17.425 26 18.775 25.7 20 25.163V27Z" />
		<path d="M19.55 17.163L17 15.463V13C17 12.45 16.55 12 16 12C15.45 12 15 12.45 15 13V16C15 16.35 15.175 16.65 15.45 16.837L18.45 18.837C18.613 18.937 18.8 19 19 19C19.55 19 20 18.55 20 18C20 17.65 19.825 17.35 19.55 17.163Z" />
	</svg>
);

export default Watch;
